import { useSelector } from 'react-redux';
import { useGetNotificationSettingFieldsQuery } from '@/middlewares/defaultApi';
import type { RootState } from '@/reducers/reducers';
import { selectIsDemoInstanceOrDemoModeEnabled } from '@/selectors/selectors';
import type { SettingField } from '@/types';

// Demo apps aren't stored, so the endpoint can't serve them; no extra fields beats a hand-copied list
const DEMO_SETTING_FIELDS: Record<string, SettingField[]> = {};

// Fields are keyed by notification id; notifications with nothing beyond channels and mentions have none
export const useNotificationSettingFields = (
    orgId: string,
    appId: string,
): {
    settingFieldsByNotificationId: Record<string, SettingField[]> | undefined;
    isLoadingSettingFields: boolean;
    isSettingFieldsError: boolean;
} => {
    const isDemoMode = useSelector((state: RootState) => selectIsDemoInstanceOrDemoModeEnabled(state, orgId));
    const { data, isFetching, isError } = useGetNotificationSettingFieldsQuery(
        { orgId, appId },
        { refetchOnMountOrArgChange: false, skip: isDemoMode },
    );

    return {
        settingFieldsByNotificationId: isDemoMode ? DEMO_SETTING_FIELDS : data?.data,
        isLoadingSettingFields: isFetching,
        isSettingFieldsError: isError,
    };
};
